import React from 'react'
import PropTypes from 'prop-types'

const RealtimePulse = ({ variant }) => {
  const colorGreen = '34,153,34'
  const colorWhite = '255,255,255'

  const color = variant === 'dark' ? colorWhite : colorGreen

  return (
    <svg
      data-testid="pulse"
      width="24"
      height="24"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(55 10 10)">
        <g style={{ transform: 'matrix(1,0,0,1,0,0)' }}>
          <path
            id="outer"
            d="M4.31674428,9.66271147 C7.24838488,6.90099267 12.0140104,6.90099267 14.9456506,9.66271147 C15.1380334,9.84532867 15.3851037,9.93517237 15.6311975,9.93517237 C15.8968225,9.93517237 16.1624475,9.82970357 16.3587366,9.62071927 C16.7376419,9.21935207 16.7190872,8.58653957 16.3167444,8.20763337 C12.6311975,4.73107087 6.63119748,4.73107087 2.94565058,8.20763337 C2.54330698,8.58653967 2.52475228,9.21935217 2.90365838,9.62071927 C3.28256468,10.0230631 3.91635368,10.0416177 4.31674428,9.66271147 Z"
          />
          <animate
            attributeName="fill"
            values={`rgb(229,229,229,0);rgb(229,229,229,0);rgb(229,229,229,0.5);rgb(${color});rgb(${color});rgb(${color});rgb(229,229,229,0.5);rgb(229,229,229,0);rgb(229,229,229,0);rgb(229,229,229,0);rgb(229,229,229,0);rgb(229,229,229,0);`}
            dur="1.8s"
            repeatCount="indefinite"
          />
        </g>
        <g style={{ transform: 'matrix(1,0,0,1,3,1.75)' }}>
          <path
            id="middle"
            d="M10.5597931,11.419709 C10.8058869,11.419709 11.0529572,11.3298652 11.24534,11.1472481 C11.6476838,10.7683418 11.6662384,10.1355293 11.2873322,9.73416224 C10.0285431,8.39724814 8.34885559,7.66189664 6.55979309,7.66189664 C4.77073059,7.66189664 3.09104259,8.39724824 1.83225359,9.73416224 C1.45334729,10.1355294 1.47190199,10.7683419 1.87424579,11.1472481 C2.27463639,11.5271309 2.90842549,11.5075997 3.28733169,11.1052559 C4.16526139,10.1745918 5.32737079,9.66189664 6.55979309,9.66189664 C7.79221539,9.66189664 8.95432439,10.1745918 9.83225399,11.1052559 C10.0285431,11.3142403 10.2941681,11.419709 10.5597931,11.419709 Z"
          />
          <animate
            attributeName="fill"
            values={`rgb(229,229,229);rgb(229,229,229);rgb(${color});rgb(${color});rgb(${color});rgb(${color});rgb(229,229,229);rgb(229,229,229);rgb(229,229,229);rgb(229,229,229);rgb(229,229,229);`}
            dur="1.8s"
            repeatCount="indefinite"
          />
        </g>
        <g style={{ transform: 'matrix(1,0,0,1,6.126,3.25)' }}>
          <path
            id="inner"
            d="M0.653112404,11.2135314 C0.301549904,11.6383361 0.360143604,12.2691955 0.785924904,12.6217345 C1.2117062,12.9752501 1.841589,12.9147033 2.194128,12.488922 C2.873816,11.6666564 3.9734254,11.6666564 4.6531129,12.488922 C4.8513551,12.7281798 5.1365113,12.8512267 5.4245973,12.8512267 C5.6492067,12.8512267 5.8747926,12.7760314 6.0613161,12.6217345 C6.4870974,12.2691954 6.5456911,11.6383361 6.1941286,11.2135314 C5.465613,10.3346251 4.4822145,9.85122665 3.4236208,9.85122665 C2.3650271,9.85122665 1.381628,10.3346252 0.653112404,11.2135314 Z"
          />
          <animate
            attributeName="fill"
            values={`rgb(229,229,229);rgb(${color});rgb(${color});rgb(${color});rgb(${color});rgb(${color});rgb(${color});rgb(229,229,229);rgb(229,229,229);rgb(229,229,229);rgb(229,229,229);`}
            dur="1.8s"
            repeatCount="indefinite"
          />
        </g>
      </g>
    </svg>
  )
}

RealtimePulse.propTypes = {
  variant: PropTypes.string.isRequired,
}

export default RealtimePulse
